import script from "./PaginationControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationControls.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationControls.vue?vue&type=style&index=0&id=f74a19ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f74a19ac"]])

export default __exports__